import React from 'react';
import ValidationError from "~/Components/Forms/ValidationError";

const AdminTranslationForm = ({values, errors, sections, onChange}) => {

    const defaultFields = {
        name: '',
        category: '',
        translation_section_id: "1"
    };

    const form = {...defaultFields, ...values};

    const handleChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let formData = {...form, [name]: value};

        onChange(formData);
    };

    return (
        <div>
            <div className="form-group">
                <label>Name</label>
                <input
                    onChange={handleChange}
                    value={form.name}
                    name="name"
                    type="text"
                    className="form-control"/>

                <ValidationError errors={errors} name="name"/>
            </div>

            <div className="form-group">
                <label htmlFor="translation_section_id">Section</label>
                <select
                    id="translation_section_id"
                    className="form-control"
                    name="translation_section_id"
                    onChange={handleChange}
                    value={form.translation_section_id}
                >
                    {
                        sections.map(item => {
                            return <option value={item.id}>{item.name}</option>
                        })
                    }
                </select>

                <ValidationError errors={errors} name="translation_section_id"/>
            </div>

            <div className="form-group">
                <label>Category</label>
                <input
                    onChange={handleChange}
                    value={form.category}
                    name="category"
                    type="text"
                    className="form-control"/>

                <ValidationError errors={errors} name="category"/>
            </div>
        </div>
    );
}


export default AdminTranslationForm;
